import { render } from "./App.vue?vue&type=template&id=6377c582"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6377c582&lang=scss"
script.render = render

export default script